export const getUdfDefaultValue = (fieldTypeId) => {
  const valueByFieldType = {
    1: "Yes",
    2: "Yes",
    3: "07-29-2025",
    4: "04:04 AM",
    5: "Sample text value",
    6: "Sample text area",
    7: "100",
    8: "Option 1",
    9: "Option 1, Option 2",
  };

  return valueByFieldType[fieldTypeId] ?? "Sample value";
};

export const candidateFieldContext = {
  data: {
    candidate: {
      email: "john.doe@example.com",
      phoneNumber: "+1 (555) 123-4567",
      mobileNumber: "+1 (555) 987-6543",
      location: "123 Main St, New York, NY 10001",
      currentTitle: "Senior Software Engineer",
    },
    candidateJobRecruiters: [{ name: "Alice Johnson" }, { name: "Bob Smith" }],
    jobSource: {
      jobDepartment: {
        name: "Engineering",
      },
    },
    atsLookupId: "77807",
    desireSalary: 120000,
    salary: 125000,
    interviewConfirmation: true,
    sourcedDate: "2024-01-15",
    firstContactedDate: "2024-01-16",
    secondContactedDate: "2024-01-18",
    thirdContactedDate: "2024-01-20",
    notInterestedDate: "2024-01-22",
    interestedDate: "2024-01-25",
    applicationDate: "2024-01-30",
    reviewCompleteDate: "2024-02-05",
    s2InterviewFirstContactedDate: "2024-02-08",
    s2InterviewSecondContactedDate: "2024-02-10",
    s2InterviewThirdContactedDate: "2024-02-12",
    s2InterviewScheduledDate: "2024-02-15",
    phoneScreenCompleteDate: "2024-02-18",
    dateSubmitted: "2024-02-20",
    dateSubmittedFeedbackReceived: "2024-02-22",
    schedulingDate: "2024-02-25",
    interviewDate: "2024-03-01",
    interviewTime: "14:00",
    interviewFeedbackReceived: "2024-03-03",
    secondInterviewDate: "2024-03-08",
    secondInterviewTime: "10:00",
    thirdInterviewDate: "2024-03-12",
    thirdInterviewTime: "15:30",
    offerApprovalDate: "2024-03-15",
    offerExtendedDate: "2024-03-18",
    offerAcceptedDate: "2024-03-20",
    pendingStartDate: "2024-04-01",
    withdrewDate: "2024-03-25",
    declinedDate: "2024-03-22",
    declinedOfferRescindedDate: "2024-03-28",
    declinedUnresponsiveDate: "2024-03-30",
    hireDate: "2024-04-01",
    startDate: "2024-04-01",
    termDate: "2024-12-31",
    outsideRetentionPeriodDate: "2025-04-01",
    isConsiderable: 1,
  },
  disabled: true,
  setCandidateActivity: () => {},
};

export const jobFieldContext = {
  form: null,
  jobTiers: [],
  users: { "Hiring Manager": [], Recruiter: [] },
  lookupTables: {},
  clientId: null,
  editData: null,
  disabled: true,
  isFormItem: false,
  style: { width: "100%" },
};
